import { useDispatch, useSelector } from 'react-redux';
import type { RootState, AppDispatch } from '@/app/store';


/**
 * Hook personalizado para acceder a la función selector tipada.
 * @returns {RootState} Función dispatch tipada
 */
export const useAppSelector = useSelector.withTypes<RootState>();


/**
 * Hook personalizado para acceder a la función dispatch tipada.
 * @returns {AppDispatch} Función dispatch tipada
 */
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
